import { Loader } from "./loader.jsx";

export const Loading = Loader